// Stored preference and resolved appearance are separate; Auto follows the OS.
export type Theme = "light" | "dark" | "system";
const KEY = "celia-theme";
let media: MediaQueryList | undefined;
let watching = false;
export function getTheme(): Theme {
  try { const value = localStorage.getItem(KEY); if (value === "light" || value === "dark" || value === "system") return value; } catch { /* Storage is optional. */ }
  return "light";
}
export function applyTheme(theme: Theme): void {
  media ??= window.matchMedia("(prefers-color-scheme: dark)");
  const resolved = theme === "system" ? media.matches ? "dark" : "light" : theme;
  document.documentElement.setAttribute("data-theme", resolved);
  document.documentElement.setAttribute("data-appearance", theme);
  if (!watching) {
    media.addEventListener("change", () => { if (getTheme() === "system") applyTheme("system"); });
    watching = true;
  }
}
export function setTheme(theme: Theme): void {
  try { localStorage.setItem(KEY, theme); } catch { /* Storage is optional. */ }
  applyTheme(theme);
}
